/**
 * Footer Document Overlay
 * Handles the interactive document download overlay
 */

(function () {
	'use strict';

	// Get elements
	const overlay = document.getElementById('documentsOverlay');
	const triggers = document.querySelectorAll('.documents-trigger a, .documents-trigger button');
	const closeBtn = document.getElementById('documentsClose');
	const backdrop = overlay ? overlay.querySelector('.documents-overlay-backdrop') : null;

	if (!overlay || triggers.length === 0) {
		return; // Exit if elements don't exist
	}

	// Open overlay
	function openOverlay(e) {
		if (e) e.preventDefault();
		overlay.classList.add('active');
		document.body.style.overflow = 'hidden';
	}

	// Close overlay
	function closeOverlay() {
		overlay.classList.remove('active');
		document.body.style.overflow = '';
	}

	// Event listeners
	triggers.forEach(trigger => {
		trigger.addEventListener('click', openOverlay);
	});

	if (closeBtn) {
		closeBtn.addEventListener('click', closeOverlay);
	}

	if (backdrop) {
		backdrop.addEventListener('click', closeOverlay);
	}

	// Close on ESC key
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && overlay.classList.contains('active')) {
			closeOverlay();
		}
	});

})();
